import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { CSVLink, CSVDownload } from "react-csv";
import ProductService from "../../services/ProductService";
import MappingService from "../../services/MappingService";
import UploaderFileService from "../../services/UploaderFileService"
import tableRequest from "../../models/tableRequest.js";
import MessageComponent from "../../template/Message";
import $, { event } from "jquery";
import { Calendar } from "primereact/calendar";
import { SelectButton } from 'primereact/selectbutton';
import Loaders from '../../template/Loaders';
import ApiService from '../../services/apiService';
import NumberGenerationService from '../../services/NumberGenerationService';
import DeMappingService from "../../services/DeMappingService";
//import SearchField from "react-search-field";
// Mapping
import moment from 'moment';
export default class Mapping extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.ProductService = new ProductService();
    this.MappingService = new MappingService();
    this.DeMappingService = new DeMappingService();
    this.NumberGenerationService = new NumberGenerationService();
    this.ApiService = new ApiService();
    this.tblResponse = new tableRequest();
    this.UploaderFileService = new UploaderFileService();

    this.state = {
      visible: false,
      show: false,
      modalIsOpen: false,
      formIsValid: true,
      updateLoader: false,
      sortOrder: "",
      buttonLabel: "Submit",
      formHeading: "Add Mapping",
      errorHeading: "Number series not valid",
      uploadImagPath: "",
      ProductImg: "",
      MappingId: 0,
      ProductId: null,
      Aufnr: "",
      Erdat: "",
      Dwerk: "",
      Quantity: "",
      DOM: "",
      DOE: "",
      BatchNo: "",
      HSN: "",
      Plant: "",
      ProductDescription: "",
      FromNo: "",
      ToNo: "",
      Qty: "",
      SapQty: "",
      Remark: "",
      BatchNo: "",
      ProcessOrder: "",
      MFGDate: "",
      EXPDate: "",
      MFGMonth: "",
      productcdformapping: "",
      ProductCd: "",
      CreatedDate: "",
      ProcessDate: "",
      DFromNumber: "",
      DToNumber: "",
      DQuantity: "",

      formError: {
        ProductId: null,
        FromNo: null,
        ToNo: null,
        Qty: null,
        BatchNo: null,
        ProcessOrder: null,
        MFGDate: null,
        EXPDate: null,
        MFGMonth: null,
        Mrp: null,



      },
      allData: [],
      Dwerk: [],
      CreateddateonDwerk: [],
      CreateddateonDwerkpatch: [],
      processorderindate: [],
      DataonProcessOrder: [],
      Products: [],
      sales: [],
      sales1: [],
      errorAll: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      isPreprinted: false,
      isPreprintedValue: "Static Qr Mapping",
      availbleFromNo: 0,
      availbleToNo: 0,
      availbleQty: 0,

    };
    this.selectTemplate = this.selectTemplate.bind(this);
    this.brandTemplate = this.brandTemplate.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.onSortFunction = this.onSortFunction.bind(this);
    this.myUploader = this.myUploader.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.hideError = this.hideError.bind(this);
    this.GetFromNo = this.GetFromNo.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.errorDialog = this.errorDialog.bind(this);
    this.GetMappingdetailonproductcode = this.GetMappingdetailonproductcode.bind(this);
    this.GetProcessCreatedDateOnPlant = this.GetProcessCreatedDateOnPlant.bind(this);
    this.FilterSapDataByCreatedDate = this.FilterSapDataByCreatedDate.bind(this);
    this.FilterSapDataByProcessOrder = this.FilterSapDataByProcessOrder.bind(this);
    this.covertStringToDate = this.covertStringToDate.bind(this);


    this.onSort = this.onSort.bind(this);
    this.setPreprintedValue = this.setPreprintedValue.bind(this);
  }
  //trigger api function on page call
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        prefix: this.ApiService.getFactoryPrefix(),
        CreatedBy: this.ApiService.getmappingcreatedby()
      });
      this.GetProductDDL('');
      this.GetMappings();
      this.GetdeMappings();
      // this.GetMappingTemplate();
      //this.GetGeneratedNumbers();
    }, 1000);
    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });
  }

  // On page call event
  onPage(event) {
    this.setState({
      loading: true,
    });

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetMappings();
      this.GetdeMappings();

    }, 250);
  }

  // use for image
  brandTemplate(rowData, column) {
    var src = rowData.ProductImg;
    return <img src={src} width="100" alt={rowData.ProductImg} />;
  }

  // set Image Path
  myUploader(event, t) {
    ;
    const fileExt = event.files[0].name.split('.').pop();
    // let errors = this.state.formError;
    // errors.ProductImg = "";
    // if (event.xhr) {
    //   if (event.xhr.response) {
    //     const response = JSON.parse(event.xhr.response);
    //     console.log(response.ResponseMessage);
    //     if (response) {
    //       if (response.ResponseCode === "200") {
    //        this.refs.child.showSuccess(response.ResponseMessage);

    //         this.setState({
    //           uploadImagPath: response.Source,
    //         });
    //       } else if (response.ResponseCode !== "200") {
    //         this.setState({
    //                   show: true,

    //                 errorAll: response.ResponseData.ErrorList
    //             });

    //        console.log("error:-",this.state.errorAll);

    //         errors.ProductImg = "Only image format is accepted.";
    //         this.setState({
    //           uploadImagPath: "",
    //         });
    //       } else {
    //       }
    //     } else {
    //       //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    //     }
    //   } else {
    //     //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    //   }
    // } else {
    //   //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    // }

    let formData = new FormData();
    let fileToUpload = event.files[0];
    formData.append("file", fileToUpload);

    if (fileExt == 'xls' || fileExt == 'xlsx') {
      this.setState({ updateLoader: false });
      this.UploaderFileService.UploadMappingExcel(formData).then(data => {
        const response = data.data;
        this.setState({ updateLoader: true });
        //if response code is 200 success message else warning message
        if (response.ResponseCode === "200") {
          this.refs.child.showSuccess(response.ResponseMessage);
          //event.files= null;
          // this.setState({
          //   uploadImagPath: response.Source,
          // });

          this.GetMappings();
          this.fileInput.current.clear();

        }
        else if (response.ResponseCode !== "200") {

          this.setState({
            show: true,
            errorAll: response.ResponseData.ErrorList,
            updateLoader: true
          });
          //this.refs.child.showError(response.ErrorMessage);
          this.fileInput.current.clear();
        }

      });
    } else {
      this.refs.child.showWarn('File extension are not acceptable.');
      this.setState({ updateLoader: true });
    }

  }

  // get product ddl list data
  GetProductDDL(search) {
    ;
    this.ProductService.GetProductsDDLSearch(search).then(data => {
      ;
      const resdata = data.data;
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === '200') {
        ;
        this.setState({

          ProductDDL: resdata.ResponseData
        });
      }
    });
  }
  // gettonoonQty(rowData){
  //   const qty = toNo - fromNo + 1;

  // }
  getProductCd(productId) {
    ;
    this.ProductService.getProductCd(productId).then(result => {
      ;
      const resdata = result.data
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === 200) {
        ;
        this.setState({
          ProductCd: resdata.ResponseData.ProductCd

        });
        const formData = {
          ProductCd: resdata.ResponseData.ProductCd,
          //ProductCd: "INTM410074",
          Plant: "",
        }

        this.GetMappingdetailonproductcode(formData)
      }
    });
  }
  GetMappingdetailonproductcode(formData) {
    ;
    this.ProductService.GetMappingdetailonproductcode(formData).then(data => {
      ;
      var resdata = data.data;
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === '200') {

        this.setState({
          Dwerk: getUniqueListBy(resdata.ResponseData, 'Dwerk'),
          // Dwerk:resdata.ResponseData,
          // Mappingdataddl: resdata.ResponseData

        });

        // console.log(this.Dwerk);
        // ;
        const arr = resdata.ResponseData;
        function getUniqueListBy(arr, key) {
          return [...new Map(arr.map(item => [item[key], item])).values()]


        }
        console.log(getUniqueListBy(resdata.ResponseData, 'Dwerk'))



        // Dwerk = getUniqueListBy(arr, 'Dwerk')

        //console.log(JSON.stringify(arr1))

      }

    });
  }

  GetProcessCreatedDateOnPlant(formData) {
    ;
    formData = {
      //ProductCd: "INTM410074",
      ProductCd: formData.value.Matnr,
      Plant: formData.value.Dwerk,
    }

    this.ProductService.GetProcessCreatedDateOnPlant(formData).then(data => {
      ;
      var resdata = data.data;
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === '200') {

        this.setState({
          CreateddateonDwerk: getUniqueListBy(resdata.ResponseData, 'Erdat'),
          // Mappingdataddl: resdata.ResponseData


        });
        ;

        const arr = resdata.ResponseData;
        function getUniqueListBy(arr, key) {
          return [...new Map(arr.map(item => [item[key], item])).values()]
        }
      }

    });
  }
  // getUnique(arr, index) {

  //   const unique = arr
  //        .map(e => e[index])

  //        // store the keys of the unique objects
  //        .map((e, i, final) => final.indexOf(e) === i && i)

  //        // eliminate the dead keys & store unique objects
  //       .filter(e => arr[e]).map(e => arr[e]);

  //    return unique;
  // }
  FilterSapDataByCreatedDate(formData) {
    formData = {


      //ProductCd: "INTM410074",
      ProductCd: formData.value.Matnr,
      Plant: formData.value.Dwerk,
      CreatedDate: formData.value.Erdat,
    }

    this.ProductService.FilterSapDataByCreatedDate(formData).then(data => {
      ;
      var resdata = data.data;
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === '200') {

        this.setState({
          processorderindate: resdata.ResponseData,
          // Mappingdataddl: resdata.ResponseData


        });
        //this.CreateddateonDwerkpatch= resdata.ResponseData;

      }

    });
  }
  covertStringToDate(dateString) {
    ;
    // if (new Date(dateString).toString() === "Invalid Date") {
    //   return false
    // }
    // else {
    const onlyNumbers = dateString.replace(/\D/g, "");
    const year = onlyNumbers.slice(0, 4)
    const month = onlyNumbers.slice(4, 6)
    const day = onlyNumbers.slice(6, 8)
    if (!month) {
      return (new Date(year))
    }
    else if (!day) {
      return (new Date(year, month - 1))
    } else {
      return (new Date(year, month - 1, day))
    }
    // }
  }
  FilterSapDataByProcessOrder(formData) {
    ;
    formData = {


      //ProductCd: "INTM410074",
      ProductCd: formData.value.Matnr,
      Plant: formData.value.Dwerk,
      CreatedDate: formData.value.Erdat,
      ProcessOrder: formData.value.Aufnr,
    }

    this.ProductService.FilterSapDataByProcessOrder(formData).then(data => {
      ;
      var resdata = data.data;
      //if resdata is not null
      if (resdata !== null && resdata.ResponseCode === '200') {

        this.setState({
          DataonProcessOrder: resdata.ResponseData[0],
          // Mappingdataddl: resdata.ResponseData
          Qty1: parseInt(resdata.ResponseData[0].Gmnga),
          Qty: parseInt(resdata.ResponseData[0].Gmnga),

          ToNo: parseInt(resdata.ResponseData[0].Gmnga) + parseInt(this.state.FromNo) - 1,
          //ToNo :gettonoonQty(resdata.ResponseData[0].Gmnga),
          MFGDate: this.covertStringToDate(resdata.ResponseData[0].Hsdat),

          EXPDate: this.covertStringToDate(resdata.ResponseData[0].Vfdat),
          BatchNo: resdata.ResponseData[0].Charg,
          HSN: resdata.ResponseData[0].Ean11,
          ProductDescription: resdata.ResponseData[0].Maktx



        });


        if (this.state.FromNo >= 1 && parseInt(resdata.ResponseData[0].Gmnga) >= 1) {

          const toNumber = parseInt(resdata.ResponseData[0].Gmnga) + parseInt(this.state.FromNo) - 1;
          if (toNumber >= 0) {
            this.setState({ ToNo: toNumber });
          } else {
            this.setState({ ToNo: 0 });
          }
        } else {
          this.setState({ ToNo: 0 });
        }
      }


    });
  }

  // // get data list from api
  // GetMappingTemplate() {
  //     this.MappingService.GetMappingTemplate(this.tblResponse).then(data => {
  //         const resdata = data.data;
  //         if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
  //             this.datasource = resdata.ResponseData;
  //             this.setState({
  //                 allData: resdata.ResponseData
  //             });
  //         } else {
  //             // this.setState({
  //             //     allData: null
  //             // });
  //         }
  //     });
  // }
  // onErrorImage() {}

  // get product mapping list data
  GetMappings() {

    //  this.tblResponse.SortColumn='MFGDate';
    this.MappingService.GetMappings(this.tblResponse).then((data) => {
      const resdata = data.data;
      //if response code is 200 success message else error or warning message

      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData.length > 0
      ) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize
          ),
          loading: false,
          updateLoader: true
        });
      } else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
          updateLoader: true

        });
      }
    });
  }
  GetdeMappings() {

    this.DeMappingService.GetDemapping(this.tblResponse).then((data) => {
      const demappeddata = data.data;
      if (
        demappeddata !== null &&
        demappeddata.ResponseData != null &&
        demappeddata.ResponseData.length > 0
      ) {
        this.datasource = demappeddata.ResponseData;
        this.setState({
          totalRecords: demappeddata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales1: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize
          ),
          loading: false,
          updateLoader: true
        });
      } else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales1: null,
          loading: false,
          updateLoader: true

        });
      }
    });
  }
  // select demapping stock
  selectTemplate(rowData, column) {

    const editMode = (e) => {
      this.setState({
        modalIsOpen: false,
        FromNo: rowData.FromNo,
        ToNo: rowData.ToNo,
        Qty: rowData.Qty,
        availbleFromNo: rowData.FromNo,
        availbleToNo: rowData.ToNo,
        availbleQty: rowData.Qty,
        isdisabled: false
      });
      console.log(this.state.availbleQty)
      //this.state.isdisabled=false
    };
    return (
      <div>
        <Button
          type="button"
          label="Select"
          onClick={editMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
      </div>
    );
  }


  // set image
  brandTemplate(rowData, column) {
    var src = rowData.ProductPic;
    return <img src={src} width="100" alt={rowData.ProductPic} />;
  }

  // edit mapping
  actionTemplate(rowData, column) {
    const editMode = (e) => {
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update Mapping",
        visible: true,
        MappingId: rowData.mappingId,
        ProductId: "" + rowData.productID,
        FromNo: rowData.fromNo,
        ToNo: rowData.toNo,
        Qty: "" + rowData.qty,
        BatchNo: rowData.BatchNo,
        ProcessOrder: rowData.Aufnr,
        MFGDate: rowData.MFGDate,
        EXPDate: rowData.EXPDate,
        MFGMonth: rowData.MFGMonth,
        Remark: rowData.Remark,
        // HSN:rowData.HSN,
        // Dwerk:rowData.Dwerk,
        // Erdat:rowData.Erdat,
        // Aufnr:rowData.Aufnr,


      });
    };
    return (
      <div>
        <Button
          type="button"
          icon="pi pi-pencil"
          onClick={editMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-danger"
        ></Button>
      </div>
    );
  }

  setPreprintedValue(e) {

    this.setState({
      isPreprintedValue: e.value,
      isPreprinted: e.value == "Static Qr Mapping" ? false : true
    }, () => {
      this.tblResponse.isPreprinted = this.state.isPreprinted;
      this.GetMappings();
    });
  }
  GetGeneratedNumbers() {
    this.tblResponse.SortColumn = 'CreatedDt';
    this.tblResponse.Prefix = this.ApiService.getFactoryPrefix();
    this.NumberGenerationService.GetGeneratedNumbers(this.tblResponse).then(data => {
      const resdata = data.data;
      //if response data is not null
      this.setState({
        updateLoader: true
      });
      if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: (this.tblResponse.First - 1),
          sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
          loading: false,
          updateLoader: true
        });
      }
      ///if response data is null
      else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
          updateLoader: true

        });
      }
    });
  }
  getBatchNoProcessOrder(productId) {
    let isValid = false;
    this.ProductService.GetBatchNoProcessOrder(productId).then((result) => {

      const resdata = result.data
      if (resdata !== null && resdata.ResponseCode === 200) {
        // this.refs.Messchild.showSuccess(resdata.ResponseMessage);
        const totlrecord = this.state.totalRecords - 1;
        const row = this.state.rows;
        if (this.tblResponse.First >= totlrecord) {
          const _curntCursor = Math.round(totlrecord / row);
          this.tblResponse.First = _curntCursor + 1;
        }
        // this.GetProductDDL();
        isValid = true;
      } else if (resdata.ResponseCode === "400") {
        this.refs.Messchild.showWarn(resdata.ResponseMessage);
      } else {
        this.refs.Messchild.showError(resdata.ResponseMessage);
      }
    });
    return isValid;
  };

  // call when input
  handleChange(event) {
    debugger;
    const { name, value } = event.target;
    let errors = this.state.formError;

    const isValid = this.validateForm(value, name);
    this.setState({ errors, [name]: value });

    if (name === "ProductId" && name !== "Remark") {
      this.getProductCd(value);
    } else if (name === "Plant") {
      this.GetProcessCreatedDateOnPlant(event);
    } else if (name === "Erdat") {
      this.FilterSapDataByCreatedDate(event);
    } else if (name === "Aufnr") {
      this.FilterSapDataByProcessOrder(event);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((this.state.ProductDDL?.length === 1) && (prevState.ProductDDL !== this.state.ProductDDL)) {
      this.handleChange({ target: { name: 'ProductId', value: this.state.ProductDDL[0]?.value } });
    }
  }
    // this.ProductService.getProductCd(event.value).then(result => {
    //   ;
    //   const resdata = result.data
    //   //if resdata is not null
    //   if (resdata !== null && resdata.ResponseCode === '200') {
    //     this.setState({
    //       ProductCd: resdata.ResponseData
    //     });
    //   }
    // });

    // this.ProductCd = this.state.ProductDDL.filter(x =>x.label == value);
    // this.GetMappingdetailonproductcode(this.ProductCd);
  
  handleChange1(event) {

    // var { name, value } = event.target;
    // let errors = this.state.formError;
    // var Value = value.Dwerk
    //  value=Value;
    var name = event.target.name;
    var value = event.target.value.Dwerk;
    let errors = this.state.formError;

    const isValid = this.validateForm(value, name);
    this.setState({ errors, [name]: value });
    console.log(this.setState({ errors, [name]: value }))
  }

  //
  // validate form
  //resolved KREP-17
  validateForm(value, name) {
    ;

    let errors = this.state.formError;
    let IsValid = true;
    //to validate each form field with required conditions
    switch (name) {
      case "ProductId":
        if (value == null) {
          IsValid = false;
          errors.ProductId = "Please select product.";
        } else errors.ProductId = null;
        break;
      case "Qty":

        if (value < 1) {
          IsValid = false;
          this.setState({ ToNo: 0 });
          errors.Qty = "Please enter +ve quantity.";
        }
        else if (this.state.Qty == "") {
          IsValid = false;
          this.setState({ ToNo: 0 });
          //errors.Qty = "quantity should Not be greater than Sap Quantity";
        }
        // else if( this.state.Qty == this.state.availbleQty  ){
        //   
        //   IsValid = false;
        //  this.setState({ ToNo: this.state.availbleQty });
        //   errors.Qty = "Quantity cannot be greater than " + this.state.availbleQty;
        // }

        //else
        //     if(value.toString().trim().length>10){
        //     IsValid=false;
        //     errors.Qty="enter valid quantity.";
        // }
        else {
          // if (!value.toString().match(/^[0-9]+$/)) {
          //   IsValid = false;
          //   errors.Qty = "Please enter only number.";
          //   this.setState({ Qty: 0 });
          // } else {
          errors.ToNo = null;
          errors.Qty = null;
          // errors.FromNo = null;
          const qty = parseInt(value);//.toString().trim() === "" ? 0 : parseInt(value.toString().trim());
          const fromNumber =
            this.state.FromNo.toString().trim() === ""
              ? 0
              : parseInt(this.state.FromNo.toString().trim());
          if (fromNumber >= 1 && qty >= 1) {
            var toNumber = qty + fromNumber - 1;
            if (toNumber >= 0) {
              this.setState({ ToNo: toNumber });
            }
            // else if(qty >= Qty1){
            //   IsValid = false;

            //   errors.Qty = "Please enter +ve quantity.";
            // }
            else {
              IsValid = false;
              errors.Qty =
                "To number should be greater than or equal to  from number.";
              this.setState({ ToNo: 0 });
            }
          }
          else {
            // IsValid = false;
            // errors.ToNo = "To number should be greater than from number.";
            this.setState({ ToNo: 0 });
          }
        }
        //}
        break;
        // case "Aufnr":
        // if (value == null) {
        //   IsValid = false;
        //   errors.Aufnr = "Please select Process Order.";
        // } else errors.Aufnr = null;
        // break;
        // case "FromNo":
        //   if (value.trim().length < 1) {
        //     IsValid = false;
        //     errors.FromNo = "Please enter your from number.";
        //   } else if (!value.match(/^[0-9]+$/)) {
        //     IsValid = false;
        //     errors.FromNo = "Please enter only number.";
        //     this.setState({ Qty: 0 });
        //   } else {
        //     errors.FromNo = null;
        //     errors.ToNo = null;
        //     errors.Qty = null;
        //     const fromNumber = value.trim() === "" ? 0 : parseInt(value.trim());
        //     const toNumber =
        //       this.state.ToNo === "" ? 0 : parseInt(this.state.ToNo);
        //     if (fromNumber >= 1 && toNumber >= 1) {
        //       if (fromNumber <= toNumber) {
        //         const qty = toNumber - fromNumber + 1;
        //         if (qty >= 0) {
        //           this.setState({ Qty: qty });
        //         } else {
        //           IsValid = false;
        //           errors.FromNo = "From number should be less than to number.";
        //           this.setState({ Qty: 0 });
        //         }
        //       } else {
        //         IsValid = false;
        //         errors.FromNo = "From number should be less than to number.";
        //         this.setState({ Qty: 0 });
        //       }
        //     } else {
        //       // IsValid = false;
        //       // errors.FromNo = "From number should be less than to number.";
        //       this.setState({ Qty: 0 });
        //     }
        //   }
        //   break;
        // case "ToNo":
        //   if (value < 1) {
        //     IsValid = false;
        //     errors.ToNo = "Please enter To Number.";
        //   } else errors.ToNo = null;
        //   break;
        // case "Qty":
        if (value < 1) {
          IsValid = false;
          errors.Qty = "Please enter +ve quantity.";
        }
        //else
        //     if(value.toString().trim().length>10){
        //     IsValid=false;
        //     errors.Qty="enter valid quantity.";
        // }
        else {
          // if (!value.toString().match(/^[0-9]+$/)) {
          //   IsValid = false;
          //   errors.Qty = "Please enter only number.";
          //   this.setState({ Qty: 0 });
          // } else {
          errors.ToNo = null;
          errors.Qty = null;
          errors.FromNo = null;
          const qty = parseInt(this.state.qty);//.toString().trim() === "" ? 0 : parseInt(value.toString().trim());
          const fromNumber =
            this.state.FromNo.toString().trim() === ""
              ? 0
              : parseInt(this.state.FromNo.toString().trim());
          if (fromNumber >= 1 && qty >= 1) {
            const toNumber = qty + fromNumber - 1;
            if (toNumber >= 0) {
              this.setState({ ToNo: toNumber });
            } else {
              IsValid = false;
              errors.Qty =
                "To number should be greater than or equal to  from number.";
              this.setState({ ToNo: 0 });
            }
          } else {
            // IsValid = false;
            // errors.ToNo = "To number should be greater than from number.";
            this.setState({ ToNo: 0 });
          }
        }
        //}
        break;


      case "BatchNo":

        if (value == "") {
          IsValid = false;
          errors.BatchNo = "Please enter Batch No";
        } else
          errors.BatchNo = null;
        break;
      case "Mrp":
        if (value.trim().length < 1) {
          IsValid = false;
          errors.Mrp = "Please enter Mrp";
        } else errors.Mrp = null;
        break;
      // case "MFGDate":
      //   if (value == null || !(value instanceof Date)) {
      //     IsValid = false;
      //     errors.MFGDate = "Please select MFG Date";
      //   } else if (
      //     !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
      //   ) {
      //     IsValid = false;
      //     errors.MFGDate = "Please enter only date.";
      //   } else errors.MFGDate = null;
      //   break;

      // case "EXPDate":
      //   if (value == null) {
      //     IsValid = false;
      //     errors.EXPDate = "Please select EXP Date";
      //   }
      //   else if (
      //     !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
      //   ) {
      //     IsValid = false;
      //     errors.EXPDate = "Please enter only date.";
      //   } else errors.EXPDate = null;
      //   break;
      // case "EXPMonth":
      //   if (value == null) {
      //     IsValid = false;
      //     errors.EXPMonth = "Please select EXP Month";
      //   }
      //   else if (
      //     !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
      //   ) {
      //     IsValid = false;
      //     errors.EXPMonth = "Please enter only date.";
      //   } else errors.EXPMonth = null;
      //   break;

      // default:
      //   break;
    }

    return IsValid;
  }

  // open dialog
  openDialog() {
    this.setState({ visible: true });
    this.formReset();
  }

  // open dialog
  errorDialog() {
    this.setState({ show: true });
  }

  hideFunc() {
    this.setState({
      visible: false,
      buttonLabel: "Submit",
      formHeading: "Add Mapping",
    });
    this.formReset();
  }

  hideError() {
    this.setState({
      show: false,

    });
  }

  // form Reset
  formReset() {
    this.setState({
      MappingId: 0,
      ProductId: null,
      FromNo: "",
      ToNo: "",
      Qty: "",
      Qty1: "",
      BatchNo: "",
      ProcessOrder: "",
      Remark: "",
      MFGDate: "",
      EXPDate: '',
      EXPMonth: '',
      HSN: "",
      Mrp: "",
      Dwerk: "",
      Erdat: "",
      Aufnr: "",
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  // submit form
  submitForm(event) {
    event.preventDefault();

    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      //form is not valid
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
    });
    ;
    //form is valid
    if (isfrmvalid) {
      this.setState({ updateLoader: false })
      const formData = {
        MappingId: this.state.MappingId,
        ProductId:
          this.state.ProductId === "" ? 0 : parseInt(this.state.ProductId),
        FromNo: this.state.FromNo === "" ? 0 : parseInt(this.state.FromNo),
        ToNo: this.state.ToNo === "" ? 0 : parseInt(this.state.ToNo),
        Qty: this.state.Qty === "" ? 0 : parseInt(this.state.Qty),
        SapQty: this.state.Qty1 === "" ? 0 : parseInt(this.state.Qty1),
        MFGDate: this.state.MFGDate,
        EXPDate: this.state.EXPDate,
        EXPMonth: this.state.EXPDate,
        BatchNo: this.state.BatchNo,
        ProcessOrder: this.state.Aufnr.Aufnr,
        Remark: this.state.Remark,
        isPreprinted: this.state.isPreprinted,
        prefix: this.ApiService.getFactoryPrefix(),
        CreatedBy: this.ApiService.getmappingcreatedby(),
        HSN: this.state.HSN,
        Mrp: this.state.Mrp,
        Plant: this.state.Plant.Dwerk, //plant
        ProcessDate: this.state.Erdat.Erdat,//Process Created Date




      };

      setTimeout(() => {

        this.MappingService.CreateMapping(formData).then((data) => {
          const resdata = data.data;
          //if ResponseCode is 200 then success message else error or warning message
          if (resdata.ResponseCode === "200") {
            this.refs.child.showSuccess(resdata.ResponseMessage);
            this.setState({
              loading: true,
              visible: false,
              updateLoader: true
            });
            // setTimeout(() => {
            if (formData.isPreprinted == false) {
              ;
              this.NumberGenerationService.CreateGeneratedNumber(formData).then(data => {
                ;

                const resdata = data.data;
                //if response code is 200 sucess else error or warning message
                if (resdata.ResponseCode === '200') {
                  this.refs.child.showSuccess(resdata.ResponseMessage);
                  this.setState({
                    loading: true,
                    visible: false,
                    downloadLink: resdata.downloadLinK,
                    updateLoader: true
                  });
                  this.formReset();
                  //this.GetGeneratedNumbers();

                  const link = document.createElement('a');
                  link.href = resdata.downloadLinK;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);


                } else if (resdata.ResponseCode === '400') {
                  this.refs.child.showWarn(resdata.ResponseMessage);
                } else {
                  this.refs.child.showError(resdata.ResponseMessage);
                }
              });
              // }, 1000);
              this.formReset();
              //this.GetGeneratedNumbers();
              this.GetMappings();
              this.GetdeMappings();
            }
            else {
              this.formReset();
              //this.GetGeneratedNumbers();
              this.GetMappings();
              this.GetdeMappings();
            }
          } else if (resdata.ResponseCode === "400") {
            this.refs.child.showWarn(resdata.ResponseMessage);
            this.setState({ updateLoader: true })
          } else {
            this.refs.child.showError(resdata.ResponseMessage);
            this.setState({ updateLoader: true })
          }
        });
      }, 1000);
    }
  }

  // get next fromNO
  GetFromNo() {
    this.formReset();
    this.setState({ visible: true });

    this.MappingService.GetFromNumberMap(this.state.isPreprinted).then((data) => {
      const resdata = data.data;
      //if ResponseCode is 200 FromNo state will be set
      if (resdata.ResponseCode === "200" && resdata.ResponseData != null) {
        let frmNumber = resdata.ResponseData.FrmNo;
        frmNumber = frmNumber ?? 0 + 1;
        this.setState({ FromNo: "" + frmNumber });
      }
    });
  }

  // set lazy load values
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = "1";
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  // serach table list
  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetMappings();
  }
  onSortFunction(event) {
    console.log(event);
  }

  // onFilterProducts(e) {
  //   
  // }

  // sort data
  onSort(event) {

    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField = event.sortField;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetMappings();
  }
  openModal = (e) => {
    e.preventDefault();

    this.setState({ modalIsOpen: true })
    this.GetdeMappings();
  }
  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  // return html
  //resolved KREP-19,KREP-126,KREP-125,KREP-122,KREP-112(CR)
  render() {
    const options = ['Static Qr Mapping', 'PrePrinted Qr Mapping'];

    let header = (


      <div style={{ textAlign: "right" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={this.searchFilter}
          placeholder="Global Search"
          size="30"
        />

        {/* <CSVLink data={this.state.allData} filename={"Mapping Template.csv"}
                        className="btn btn-primary ml-2"
                        target="_blank">Download Template</CSVLink> */}
      </div>

    );
    return (
      <>

        <MessageComponent ref="child" />
        <Loaders loader={this.state.updateLoader} />
        <div className="heading">
          <h1>Product Mapping</h1>
          <div className="row mt-3">
            <div className="col-md-6">
              <SelectButton className="custom-tab" value={this.state.isPreprintedValue} options={options} onChange={this.setPreprintedValue} />
            </div>
            <div className="col-md-6 text-right">
              <Button

                label="Product Mapping"
                icon="pi pi-plus-circle"
                onClick={this.GetFromNo}
              />
            </div>
          </div>

        </div>

     
<DataTable
  responsive={true}
  header={header}
  scrollable={true}
  style={{ width: "100%" }}
  globalFilter={this.state.globalFilter}
  emptyMessage={this.state.emptyMessage}
  value={this.state.sales}
  sortMode="single"
  paginator={true}
  rows={this.state.rows}
  rowsPerPageOptions={[5, 10, 20]}
  totalRecords={this.state.totalRecords}
  lazy={true}
  first={this.state.first}
  onPage={this.onPage}
  onSort={this.onSort}
  scrollHeight="400px"  // Add fixed height for scrolling
>
  <Column
    field="ProductCd"
    header="Product Code"
    style={{ minWidth: "150px", maxWidth: "200px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="ProductName"
    header="Product Name"
    style={{ minWidth: "180px", maxWidth: "250px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="ProductDscrptn"
    header="Product Description"
    style={{ minWidth: "200px", maxWidth: "300px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="FromNo"
    header="From No."
    style={{ width: "100px" }}
    sortable={true}
  />
  <Column
    field="ToNo"
    header="To No."
    style={{ width: "100px" }}
    sortable={true}
  />
  <Column
    field="Qty"
    header="Quantity"
    style={{ width: "100px" }}
    sortable={true}
  />
  <Column
    field="SapQuantity"
    header="Sap Qty"
    style={{ width: "100px" }}
    sortable={true}
  />
  <Column
    field="MFGDate"
    header="MFG Date"
    style={{ width: "120px" }}
    sortable={true}
  />
  <Column
    field="EXPDate"
    header="EXP Date"
    style={{ width: "120px" }}
    sortable={true}
  />
  <Column
    field="EXPMonth"
    header="EXP Month"
    style={{ width: "120px" }}
    sortable={true}
  />
  <Column
    field="BatchNo"
    header="Batch No"
    style={{ minWidth: "120px", maxWidth: "150px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="Processorder"
    header="ProcessOrder"
    style={{ minWidth: "130px", maxWidth: "160px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="Mrp"
    header="MRP"
    style={{ width: "100px" }}
    sortable={true}
  />
  <Column
    field="Remark"
    header="Remarks"
    style={{ minWidth: "150px", maxWidth: "200px" }}
    sortable={true}
    bodyStyle={{ wordWrap: "break-word", whiteSpace: "normal" }}
  />
  <Column
    field="CreatedDt"
    header="Created Date"
    style={{ width: "130px" }}
    sortable={true}
  />
</DataTable>
        <div className="row">

          <div className="col-md-12 mt-5">
            {/* remove for sap */}
            {/* <label>Upload Excel(.xlsx or .xls):</label> */}

            {/* <FileUpload ref={this.fileInput} name="mappingfile[]" value={this.state.mappingfile}
              customUpload uploadHandler={e => { this.myUploader(e, this) }}
              accept=".xlsx" /> */}
            {/* {this.state.uploadImagPath ? (
                      <div className="p-fileupload-row">
                        <div>
                          <img
                            alt="file.xlsx"
                            role="presentation"
                            src={this.state.uploadImagPath}
                            width="50"
                          />
                        </div>
                      </div>
                    ) : null} */}
            {/* <a className="btn btn-primary mt-3 pt-2 pb-2" href={require('../../assets/ExcelTemplate/Mapping_details.xlsx')} download="Mapping_details.xlsx">Download Template </a> */}
          </div>

          {/* <div className="col-md-8 mt-5 pt-5">
        <button className="btn btn-primary">Save</button>
        </div>           */}
        </div>
        {/* <div>
response.ErrorMessage
</div> */}



        <Dialog
          className="popup-modal"
          header={this.state.formHeading}
          visible={this.state.visible}
          modal={true}
          onHide={this.hideFunc}
        >
          <form onSubmit={this.submitForm} className="form-padding">
            <div className="row">
              <div className="col-md-4 text-right">
                <label>Product <span>*</span>:</label>
              </div>
              {/* <SearchField
                placeholder="Search..."
                onChange={this.onFilterProducts}
                searchText="This is initial search text"
                classNames="test-class"
              /> */}
          <div className="col-md-8 mb-2">
        <div id="myDropdown" className="dropdown-content">
          <input
            type="text"
            onKeyUp={(event) => this.GetProductDDL(event.target.value)}
            placeholder="Search"
            id="myInput"
          />
          <select
            onChange={this.handleChange}
            value={this.state.ProductId}
            name="ProductId"
          >
            {this.state.ProductDDL?.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
        </div>
        {/* 
        <Dropdown options={this.state.ProductDDL} onFilterInputChange={this.onFilterProducts} filter placeholder="Select Product" className="form-control" value={this.state.ProductId} onChange={this.handleChange} name="ProductId" />
        {this.state.formError.ProductId !== null ?
          <div className='error'>{this.state.formError.ProductId}</div> : null} 
        */}
      </div>

              <div className="col-md-4 text-right">
                <label>Plant <span>*</span>:</label>
              </div>
              <div className="col-md-8 mb-2">
                <Dropdown options={this.state.Dwerk} filter placeholder="Select Plant" className="form-control" value={this.state.Plant} onChange={e => { this.handleChange(e); }} optionLabel="Dwerk" name="Plant" />
                {/* {this.state.formError.Dwerk !== null ?
                  <div className='error'>{this.state.formError.Dwerk}</div> : null} */}
              </div>
              <div className="col-md-4 text-right">
                <label>Process Date <span>*</span>:</label>
              </div>
              <div className="col-md-8 mb-2">
                <Dropdown options={this.state.CreateddateonDwerk} filter placeholder="Select Process Created Date" className="form-control" value={this.state.Erdat} optionLabel="Erdat" onChange={e => { this.handleChange(e); }} name="Erdat" />
                {/* {this.state.formError.ProductId !== null ?
                  <div className='error'>{this.state.formError.ProductId}</div> : null} */}
              </div>
              <div className="col-md-4 text-right">
                <label>Process Order <span>*</span>:</label>
              </div>
              <div className="col-md-8 mb-2">
                <Dropdown options={this.state.processorderindate} filter placeholder="Select Process order No." className="form-control" value={this.state.Aufnr} optionLabel="Aufnr" onChange={e => { this.handleChange(e); }} name="Aufnr" />
                {this.state.formError.Aufnr !== null ?
                  <div className='error'>{this.state.formError.Aufnr}</div> : null}
              </div>
              {/* <div className="col-md-4 text-right">
                <label>
                ProcessOrder<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  value={this.state.ProcessOrder}
                  onChange={this.handleChange}
                  className="form-control"
                  name="ProcessOrder"
                />
                {this.state.formError.ProcessOrder !== null ? (
                  <div className="error">{this.state.formError.ProcessOrder}</div>
                ) : null}
              </div> */}

              <div className="col-md-4 text-right">
                <label>
                  From No.<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  readOnly
                  type="text"
                  id="txtProductId"

                  value={this.state.FromNo}
                  // onChange={this.handleChange}
                  className="form-control"
                  name="FromNo"
                />
                {this.state.formError.FromNo !== null ? (
                  <div className="error">{this.state.formError.FromNo}</div>
                ) : null}
                <Button
                  label="Demapped Series"
                  onClick={this.openModal}
                />
              </div>



              <div className="col-md-4 text-right">
                <label>
                  Sap Quantity<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="number"
                  value={this.state.Qty1}
                  readOnly
                  // onChange={this.handleChange}
                  className="form-control"
                  name="Qty1"
                />
                {this.state.formError.Qty !== null ? (
                  <div className="error">{this.state.formError.Qty1}</div>
                ) : null}
              </div>

              <div className="col-md-4 text-right">
                <label>
                  Quantity<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="number"
                  value={this.state.Qty}

                  onChange={this.handleChange}
                  className="form-control"
                  name="Qty"
                />
                {this.state.formError.Qty !== null ? (
                  <div className="error">{this.state.formError.Qty}</div>
                ) : null}
              </div>

              <div className="col-md-4 text-right">
                <label>
                  To No.<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  readOnly
                  value={this.state.ToNo}
                  // onChange={this.handleChange}
                  className="form-control"
                  name="ToNo"
                />
                {this.state.formError.ToNo !== null ? (
                  <div className="error">{this.state.formError.ToNo}</div>
                ) : null}
              </div>

              <div className="col-md-4 text-right">
                <label>
                  D.O.M.<span>*</span>:
                </label>
              </div>
              {/* <div className="col-md-8 mb-2">
                <input
                  type="text"
                  readOnly
                  value={this.state.MFGDate}
                  //onChange={this.handleChange}
                  className="form-control"
                  name="MFGDate"
                /> */}
              <div className="col-md-8 mb-2">
                <Calendar
                  className="custom-calender"
                  value={this.state.MFGDate}
                  // onChange={this.handleChange}
                  showIcon={true}
                  appendTo={document.getElementById("root")}
                  name="MFGDate"
                  disabled={true}
                  dateFormat="dd/mm/yy" // Set the desired date format here
                />
              </div>


              <div className="col-md-4 text-right">
                <label>
                  Exp. Date<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <div className="row">
                  <div className="col-md-6">
                    <Calendar
                      readOnly
                      //minDate={this.state.MFGDate}
                      className="custom-calender"
                      value={this.state.EXPDate}
                      // onChange={this.handleChange}
                      showIcon={true}
                      appendTo={document.getElementById("root")}
                      name="EXPDate"
                      disabled={true}
                      dateFormat="dd/mm/yy" // Set the desired date format here
                    />
                  </div>
                  <div className="col-md-6">
                    <Calendar dateFormat="MM yy"
                      // minDate={this.state.MFGMonth}
                      className="custom-calender-month"
                      value={this.state.EXPDate}
                      //  onChange={this.handleChange}
                      showIcon={true}
                      appendTo={document.getElementById("root")}
                      name="EXPMonth"
                      disabled={true}
                    />
                  </div>
                </div>
                {/* {this.state.formError.MFGMonth !== null ? (
                  <div className="error">{this.state.formError.EXGDate}</div>
                ) : null} */}
              </div>

              <div className="col-md-4 text-right">
                <label>
                  Batch No<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  readOnly
                  type="text"
                  value={this.state.BatchNo}
                  // onChange={this.handleChange}
                  className="form-control"
                  name="BatchNo"
                />
                {this.state.formError.BatchNo !== null ? (
                  <div className="error">{this.state.formError.BatchNo}</div>
                ) : null}
              </div>
              <div className="col-md-4 text-right">
                <label>
                  HSN No.<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  readOnly
                  type="text"
                  value={this.state.HSN}
                  //  onChange={this.handleChange}
                  className="form-control"
                  name="HSN"
                />
                {/* {this.state.formError.HSN !== null ? (
                  <div className="error">{this.state.formError.HSN}</div>
                ) : null} */}
              </div>
              {/* <div className="col-md-4 text-right">
                <label>
                ProcessOrder<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  value={this.state.ProcessOrder}
                  onChange={this.handleChange}
                  className="form-control"
                  name="ProcessOrder"
                />
                {this.state.formError.ProcessOrder !== null ? (
                  <div className="error">{this.state.formError.ProcessOrder}</div>
                ) : null}
              </div> */}
              <div className="col-md-4 text-right">
                <label>
                  MRP.<span>*</span>:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input

                  type="number"
                  value={this.state.Mrp}
                  onChange={this.handleChange}
                  className="form-control"
                  name="Mrp"
                />
                {this.state.formError.Mrp !== null ? (
                  <div className="error">{this.state.formError.Mrp}</div>
                ) : null}
              </div>

              <div className="col-md-4 text-right">
                <label>Remark:</label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  value={this.state.Remark}
                  onChange={this.handleChange}
                  className="form-control"
                  name="Remark"
                />
              </div>

              <div className="col-md-12 text-center">
                <button type="submit" className="btn btn-primary">
                  {this.state.buttonLabel}
                </button>
              </div>
            </div>
            <div>
              <label>
                Note: Fields marked as (<span style={{ color: "red" }}>*</span>)
                are required
              </label>
            </div>
          </form>

        </Dialog>





        <Dialog
          visible={this.state.show}
          style={{ width: "60%" }}
          onHide={this.hideError}
          className="popup-modal"
          header={this.state.errorHeading}

        >
          <DataTable
            responsive={true}
            style={{ width: "100%" }}
            emptyMessage={this.state.emptyMessage}
            value={this.state.errorAll}
            sortMode="multiple"
            rows={this.state.rows}
            rowsPerPageOptions={[5, 10, 20]}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            loading={this.state.loading}
          >
            <Column
              field="ProductCd"
              header="Product Code"
              style={{ width: "100px" }}
            />

            <Column
              field="FromNo"
              header="From No."
              style={{ width: "120px" }}
            />
            <Column
              field="ToNo"
              header="To No."
              style={{ width: "120px" }}
            />
            <Column
              field="Qty"
              header="Quantity"
              style={{ width: "100px" }}
            />

            <Column
              field="Error"
              header="Error Message"
              style={{ width: "170px" }}
            />

            <Column
              field="BatchNo"
              header="Batch No"
              style={{ width: "100px" }}
            />
            <Column
              field="ProcessOrder"
              header="ProcessOrder"
              style={{ width: "100px" }}
            />
          </DataTable>
        </Dialog>
        <Dialog header="De-mapped Series" visible={this.state.modalIsOpen} style={{ width: '40vw' }} onHide={this.closeModal} >
          <DataTable responsive={true}
            style={{ width: "100%" }}
            emptyMessage={this.state.emptyMessage}
            value={this.state.sales1}
            sortMode="multiple"
            rows={this.state.rows}
            rowsPerPageOptions={[5, 10, 20]}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            loading={this.state.loading}
          >
            <Column field="DeMappingId" header="Seq No"></Column>
            <Column field="FromNo" header="From No"></Column>
            <Column field="ToNo" header="To No"></Column>
            <Column field="Qty" header="Quantity"></Column>
            <Column
              field="Action"
              header="Action"
              style={{ width: "25%" }}
              body={this.selectTemplate}
            >
            </Column>
          </DataTable>

        </Dialog>
      </>
    );
  }
}
